import React, { useState, useEffect } from "react";
import {
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
  Typography,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { connect } from "react-redux";
import {
  setCobrowsetype,
  setCobrowseemail,
  setCobrowsephonenumber,
} from "../../../../redux/actions/actions";
import { AiFillCloseCircle } from "react-icons/ai";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const mapStateToProps = (state) => {
  console.log('selectedmobile',state.data.selectedmobile)
  return {
    cobrowsertype: state.data.cobrowsertype,
    selectedemail: state.data.selectedemail,
    selectedmobile: state.data.selectedmobile,
  };
};

const Cobrowser = (props) => {
  const [cobrowsetype, setcobrowsetype] = useState('');
  const [email, setEmail] = useState(props.selectedemail || '');
  const [mobile, setMobile] = useState(formatMobileNumber(props.selectedmobile || ''));
  const [emailError, setEmailError] = useState(false);

  function formatMobileNumber(number) {
    if (number.startsWith('0')) {
      return `971${number.slice(1)}`;
    }else if(number.startsWith('971')){
      return number;
    }else{
      return `971${number}`;
    }
  
  }
  useEffect(() => {
    if (mobile.startsWith('0')) {
      const formattedMobile = `971${mobile.slice(1)}`;
      console.log('formattedMobile',formattedMobile)
      setMobile(formattedMobile);
    }
  }, [mobile]);


  
  useEffect(() => {
    setCobrowseemail(email);
    setCobrowsephonenumber(mobile);
  }, [cobrowsetype,props.selectedemail,props.selectedmobile]);

  const {
    OpenDialog,
    handleClose,
    CobrosweData,
    setCobrowserInput,
    setUrlValidationError,
    UrlvalidationError,
    setCobrowsetype,
    setCobrowseemail,
    setCobrowsephonenumber,
    setcobrowseselecttype,
    cobrowseselecttype,
    cobrowseselecttypeerror,
    setcobrowseselecttypeerror
  } = props;

  const handleTypeChange = (e) => {
    setcobrowseselecttype(e.target.value);
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };
  const handleEmailChange = (e) => {
    console.log('emailvalue',e.target.value)
    const value = e.target.value;
    console.log('emailvaluevalue',value)
    setEmail(value);
    if (validateEmail(value) && value!=='Empty') {
      setEmailError(false);
      setCobrowseemail(value);
    } else {
      setEmailError(true);
    }
  };

  console.log('emailll',email)

  return (
    <Dialog
      open={OpenDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      sx={{
        "& .MuiPaper-root": {
          borderRadius: 5,
          padding: 1,
          top: -100,
        },
        backgroundColor: "rgb(0 0 0 / 65%)",
      }}
    >
      <DialogTitle
        variant="subtitle2"
        sx={{ fontSize: "16px", fontWeight: 600 }}
      >
        <div className="d-flex justify-content-between">
          <span>Request Co-Browser</span>
          <span>
            <AiFillCloseCircle onClick={handleClose} />
          </span>
        </div>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Stack>
            <select
              className="form-select form-select-lg mb-3"
              aria-label=".form-select-lg example"
              onChange={handleTypeChange}
              value={cobrowseselecttype}
            >
              <option value="">Select Type</option>
              <option value="Email">Email</option>
              <option value="sms">SMS</option>
            </select>
            {cobrowseselecttype==''?
                <Typography variant="body2" sx={{ color: "red",marginTop:'-10px' }}>
                Select Type *
              </Typography>:''
          }

    


            {cobrowseselecttype === "Email" ? (
              <>
              <input
                className="form-control"
                placeholder="Enter a valid email"
                style={{ height: "40px", width: "450px" }}
                value={email=='Empty'?'':email}
                onChange={
                  // setEmail(e.target.value);
                  // setCobrowseemail(e.target.value);
                  handleEmailChange
                }
              />
                  {emailError ? 
                  <Typography variant="body2" sx={{ color: "red" }}>
                    Please Select A Valid Email *
                  </Typography>:''
                }
              </>
              
           
            ) : (
              ''
            )}

            {cobrowseselecttype === "sms" ? (
              <input
                className="form-control"
                type="number"
                placeholder="Enter a valid phone number"
                style={{ height: "40px", width: "450px" }}
                required={true}
                value={mobile}
                onChange={(e) => {
                  // setEmail('');
                  setMobile(e.target.value);
                  setCobrowsephonenumber(e.target.value);
                }}
              />
             
            ) : (
              ''
            )}
          </Stack>
          <Stack spacing={0.5} className="my-1">
            <input
              className="form-control"
              onChange={(e) => {
                const coBrowvalue = e.target.value;
                if (coBrowvalue.length === 0 || coBrowvalue.trim() !== '') {
                  setCobrowserInput(coBrowvalue);
                  setUrlValidationError("");
                }
              }}
              placeholder="Ex: www.setUrl.com"
              style={{ height: "40px", width: "450px" }}
            />
            {UrlvalidationError && (
              <Typography variant="body2" sx={{ color: "red" }}>
                {UrlvalidationError}
              </Typography>
            )}
          </Stack>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={
            ()=>{
              if(cobrowseselecttype=='Email' && email=='Empty'){
                setEmailError(true)
                
              }else if(cobrowseselecttype=='sms'){
                console.log('calllle')
                CobrosweData()
              }else{
                setEmailError(false)
                CobrosweData()
               
              }
            }
            
          }
          // onClick={CobrosweData}

           
          variant="contained"
          size="small"
          endIcon={<PaperPlaneTilt size={15} />}
        >
          Yes Request Co-Browser
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {
  setCobrowsetype,
  setCobrowseemail,
  setCobrowsephonenumber,
})(Cobrowser);
